import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DocumentFormWithPricing from './DocumentFormWithPricing';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const DocumentEdit = ({ document, onBack, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.put(`${API}/documents/${document.id}`, formData);
      
      if (onSave) {
        onSave(response.data);
      }
      
      alert('Document modifié avec succès !');
      onBack();
    } catch (error) {
      console.error('Erreur lors de la modification:', error);
      setError(error.response?.data?.detail || 'Erreur lors de la modification du document');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onBack();
  };

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          Modifier le document {document.reference}
        </h2>
        <button
          onClick={onBack}
          className="text-gray-600 hover:text-gray-800 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          ← Retour
        </button>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-100 border border-red-300 text-red-700 rounded-lg">
          {error}
        </div>
      )}

      <DocumentFormWithPricing
        document={document}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />
    </div>
  );
};

export default DocumentEdit;